import { ApiRequestInfo } from "types/anya";
import { sha256Hash } from "views/Dashboards/anyaUtils";

/**
 * Recursively sorts object keys for deterministic JSON stringification.
 * Handles nested objects and arrays.
 */
function sortObjectKeys(obj: unknown): unknown {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(sortObjectKeys);
  }

  const sorted: Record<string, unknown> = {};
  Object.keys(obj as Record<string, unknown>)
    .sort()
    .forEach((key) => {
      sorted[key] = sortObjectKeys((obj as Record<string, unknown>)[key]);
    });
  return sorted;
}

/**
 * Generates a unique API key from request information for widget data caching.
 */
export async function generateApiKey(
  requestInfo: ApiRequestInfo,
): Promise<string> {
  const { url, method, data, params } = requestInfo;

  const requestSignature = {
    url,
    method,
    data: data || {},
    params: params || {},
  };

  const sortedSignature = sortObjectKeys(requestSignature);
  return sha256Hash(JSON.stringify(sortedSignature));
}
